import parseBoolean from "./config/parseBoolean";
import { getModelFromInput } from '../../common/getModelFunctions';

export default {
	model: {
		value: {
			default: false
		}
	},
	computed: {
		input_set() {
			const inputs = this.$el.dataset.inputs.split(',');
			const input = inputs[0];

			return parseBoolean(getModelFromInput(input, this.$model, true));
		},
		input_reset() {
			const inputs = this.$el.dataset.inputs.split(',');
			const input = inputs[1];

			return parseBoolean(getModelFromInput(input, this.$model, true));
		}
	},
	watch: {
		input_set() {
			if (this.data.input_set && !this.data.input_reset) this.data.value = true;
		},
		input_reset() {
			if (this.data.input_reset) this.data.value = false;
		}
	},
	listeners: {
		click: true
	}
};
